import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55b0c694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-comp-common" }
const _hoisted_2 = { class: "result-area" }
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = { class: "result-title" }
const _hoisted_5 = { class: "image-area" }
const _hoisted_6 = { class: "result-text" }
const _hoisted_7 = { class: "name-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "button-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cplt_round_lottie = _resolveComponent("cplt-round-lottie")!
  const _component_mv_button = _resolveComponent("mv-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('receiveNtfc.saleCplt.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_cplt_round_lottie)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.info.name), 1),
        _hoisted_8,
        _createTextVNode(_toDisplayString(_ctx.$t('receiveNtfc.saleCplt.text')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_mv_button, {
        type: "rec-primary",
        text: "common.confirm",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ok')))
      })
    ])
  ]))
}